<div *ngIf="filteredCourierId != null" class="show-all" (click)="filterChanged.emit(null)">
    <i class="fa fa-times" aria-hidden="true"></i>
    {{ 'delivery-plan-viewer.show-all' | translate }}
</div>

<div
    *ngFor="let item of items; trackBy: trackByCourierId"
    class="legend-item"
    [class.is-selected]="item.courierId === filteredCourierId"
    [class.is-dimmed]="filteredCourierId != null && item.courierId !== filteredCourierId"
    [style.background]="item.courierId === filteredCourierId ? selectedBackground(item.color) : null"
    [style.border-color]="item.courierId === filteredCourierId ? item.color : null"
    (click)="onItemClicked(item)"
>
    <span class="legend-item__dot" [style.background]="item.color"></span>
    <span class="legend-item__label">{{ item.label }}</span>
    <i
        *ngIf="item.courierId === filteredCourierId"
        class="fa fa-filter legend-item__filter"
        [style.color]="item.color"
        aria-hidden="true"
    ></i>
</div>